import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Gift } from "react-bootstrap-icons";

import AppContext from "../../appContext";
import CustomButton from "../../components/buttons/button";
import MarcaPropriaAlert from "../../shared/components/marca-propria/marca-propria-alert";
import { getPromocoesMarcaPropria } from "../../Functions/gestao-promocao-laboratorio/get-promocoes";

import styles from "./marca-propria-cta.module.css";

const MarcaPropriaCta = ({ laboratorio_cnpj, laboratorio_nome, pedido_laboratotio }) => {
	const context = useContext(AppContext);
	const [promocoes, setPromocoes] = useState([]);
	const [redirectState, setRedirectState] = useState(null);

	useEffect(() => {
		let ativo = true;

		getPromocoesMarcaPropria(pedido_laboratotio, laboratorio_cnpj).then(resultado => {
			if (ativo) {
				setPromocoes(resultado);
			}
		});

		return () => {
			ativo = false;
		};
	}, [pedido_laboratotio, laboratorio_cnpj]);

	if (redirectState) {
		return <Redirect to={{ pathname: "/order", state: redirectState }} />;
	}

	if (promocoes.length === 0) {
		return null;
	}

	const iniciarPedidoPromocional = () => {
		context.showLoading("");

		const requestOptions = {
			method: "POST",
			body: JSON.stringify({
				cnpjs: context.userSession.laboratorios,
				papel: context.userSession.papel,
				conta: context.userSession.conta,
			}),
		};

		fetch(process.env.REACT_APP_LABS_API + "get_labs.php", requestOptions)
			.then(response => response.json())
			.then(json => {
				context.hideLoading();

				const lab = (json.items || []).find(item => item.CNPJ_c === laboratorio_cnpj) || {};

				setRedirectState({
					lab: laboratorio_cnpj,
					name: lab.Nome_c || laboratorio_nome,
					logo: lab.URL_Logo_c || "",
					telefone: lab.Telefone_c || "",
					site: lab.Site_c || "",
					email: lab.Email_c || "",
					promo: lab.Promocao_c || false,
					corteRemoto: lab.RemoteEdge_c || false,
					detailOrder: lab.DetalhesDoPedido_c || false,
					promo_code: "",
					promo_proximo_par: null,
					IsCor_AR: lab.IsCor_AR_c || false,
					IsGrowmocao: lab.Growmocao_c || false,
					CorteMontagemObrigatorio: lab.CorteMontagemObrigatorio_c || false,
					colorirNaOtica: lab.ColorirNaOtica_c || false,
					IsPacto: lab.Pacto_c || false,
					IsPactoNovaJornada: lab.PactoNovaJornada_c || false,
					ArmacaoUsadaNova: lab.ArmacaoUsadaNova_c || false,
					MontagemTipoArmacao: lab.MontagemTipoArmacao_c || false,
					marcaPropria: {
						pedidoOrigem: pedido_laboratotio,
						promocoes: promocoes,
					},
				});
			})
			.catch(() => {
				context.hideLoading();
			});
	};

	return (
		<div className={styles.ctaContainer}>
			<MarcaPropriaAlert id={`alert-marca-propria-tracking-${pedido_laboratotio}`}>
				<Gift size={16} />
				<br />
				Seu pedido é elegível para realizar um novo <strong>pedido promocional</strong> do laboratório{" "}
				<strong>{laboratorio_nome}</strong>.
				<CustomButton
					id={`btn-fazer-pedido-marca-propria-${pedido_laboratotio}`}
					label="FAZER PEDIDO"
					width="12rem"
					height="2.75rem"
					marginTop="1rem"
					onClick={iniciarPedidoPromocional}
				/>
			</MarcaPropriaAlert>
		</div>
	);
};

export default MarcaPropriaCta;
